import { loadStripe } from "@stripe/stripe-js"
import api from "../../../../../../api/axios"

const FRONTEND_SERVER = {
    "localhost:8080": "localhost:8080",
    "my.salusion-staging.com": "@",
    "my.salusion-preprod.com": "@",
    "my.salusion.com": "@"
}

export async function getPlanTypes(employerId, token) {
    const response = await api.get(`/employer/${employerId}/plan/v2`, { params: { token } })
    const plans = response?.data?.data
    return plans?.map((plan) => plan.type)
}

export async function getAccounts(employerId) {
    const response = await api.get(`/employer/${employerId}/account`)
    return response?.data?.employerAccounts
}

export async function getBankAccounts(employerId) {
    const response = await api.get(`/employer/${employerId}/bankAccount`, { params: { includeNumbers: true } })
    return response?.data
}

export async function getStripeAccount(employerId) {
    const response = await api.get(`/employer/${employerId}/billing/v2/subscription`, { params: { include: true } })
    return response?.data?.data?.[0]
}

export async function getStripeConfig(employerId) {
    const host = window?.location?.host
    const server = FRONTEND_SERVER?.[host]
    const path = window?.location?.pathname
    const params = window?.location?.search

    let onSuccess = `${path}?stripe=success`
    let onCancel = `${path}`

    if (params) {
        onSuccess = `${path}${params}&stripe=success`
        onCancel = `${path}${params}`
    }

    const response = await api.post(`/employer/${employerId}/billing/subscription/checkout`, {
        server,
        onSuccess,
        onCancel
    })
    return response?.data
}

export async function setAccount(employerId, payload) {
    await api.post(`/employer/${employerId}/account`, payload)
}

export async function setStripeAccount(employerId, sessionId, mode) {
    await api.post(`/employer/${employerId}/billing/subscription`, {
        checkoutSessionId: sessionId
    })
    localStorage.removeItem(`stripe-${employerId}`)
}

export async function setCreditCard(employerId, mode) {
    console.log("Setting credit card with mode:", mode)
    const stripeConfig = await getStripeConfig(employerId)
    stripeConfig.mode = mode

    const { publishableKey, sessionId } = stripeConfig

    if (publishableKey && sessionId) {
        localStorage.setItem(`stripe-${employerId}`, JSON.stringify(stripeConfig))
    }

    try {
        const stripe = await loadStripe(publishableKey)
        await stripe.redirectToCheckout({ sessionId })
    } catch (error) {
        console.error("Stripe redirect error:", error)
    }
}

export async function updateStripeAccount(employerId) {
    console.log("UpdateStripeAccount for employerId:", employerId)
    try {
        const rawValue = localStorage.getItem(`stripe-${employerId}`)
        console.log("Raw stripe config from localStorage:", rawValue)
        if (!rawValue) {
            console.log("No stripe config found in localStorage")
            return
        }
        
        const stripeConfig = JSON.parse(rawValue)
        console.log("Parsed stripeConfig:", stripeConfig)
        if (stripeConfig?.sessionId) {
            console.log("Calling setStripeAccount with sessionId:", stripeConfig.sessionId, "mode:", stripeConfig.mode)
            await setStripeAccount(employerId, stripeConfig.sessionId, stripeConfig.mode)
            localStorage.removeItem(`stripe-${employerId}`)
        }
    } catch (error) {
        console.error("Error updating Stripe account:", error)
        localStorage.removeItem(`stripe-${employerId}`)
        throw error
    }
}

export default {
    getPlanTypes,
    getAccounts,
    getBankAccounts,
    getStripeAccount,
    getStripeConfig,
    setAccount,
    setStripeAccount,
    updateStripeAccount,
    setCreditCard
}